export default "__VITE_ASSET__DUmY$CX5__"